module.exports = __webpack_public_path__ + "static/284-14878acff5951fffc1401243d4dec3ef.png";